import request from '@/modules/base/util/request'
import config from '@/config'
import { BuhlArchivConnectionStatus } from '@/redux/ducks/buhlArchiv/connection'

const apiPath = `${config.resourceHost}buhlArchiv`

export interface IBuhlArchivConnectionInfo {
  status: BuhlArchivConnectionStatus
  email: string | undefined
}

export enum BuhlArchivTransferStatus {
  NOT_TRANSFERRED = 'notTransferred',
  TRANSFERRED = 'transferred',
  ERROR = 'error',
}

class BuhlArchivService {
  /**
   * Gets the connection information of the buhl:Archiv
   * @returns The connection information
   */
  async getConnectionInfo(): Promise<IBuhlArchivConnectionInfo> {
    const response = await request(`${apiPath}/connection-info`, {
      auth: true,
      isConcurrent: true,
      method: 'GET',
    })

    return response.body.data as IBuhlArchivConnectionInfo
  }

  /**
   * Connects to the buhl:Archiv
   * @param token - The token of the Buhl account
   * @returns The connection information
   */
  async connect(token: string): Promise<IBuhlArchivConnectionInfo> {
    const response = await request(`${apiPath}/connect`, {
      auth: true,
      isConcurrent: true,
      method: 'POST',
      data: { token },
    })

    return response.body.data as IBuhlArchivConnectionInfo
  }

  /**
   * Prepares the connection to the buhl:Archiv
   * @returns The token for the buhl:Archiv
   */
  async prepareConnection(): Promise<string> {
    const response = await request(`${apiPath}/prepare-connection`, {
      auth: true,
      isConcurrent: true,
      method: 'POST',
    })

    return response.body.data.token as string
  }

  /**
   * Disconnects from the buhl:Archiv
   * @returns The connection information
   */
  async disconnect(): Promise<IBuhlArchivConnectionInfo> {
    const response = await request(`${apiPath}/disconnect`, {
      auth: true,
      isConcurrent: true,
      method: 'DELETE',
    })

    return response.body.data as IBuhlArchivConnectionInfo
  }

  /**
   * Transfers the euer export to the buhl:Archiv
   * @param euerExportId - The id of the euer export
   * @returns The response from the server
   */
  async transferEuerToBuhlArchiv(euerExportId: string): Promise<{ buhlArchivId: string, transferredAt: string, transferredTo: string }> {
    const response = await request(`${apiPath}/transfer/${euerExportId}`, {
      auth: true,
      isConcurrent: true,
      method: 'POST',
    })

    return response.body.data
  }
}

export default new BuhlArchivService()
